import { LoadingCircle } from "@/components/ui/loadingCircle";
import { cn } from "@/lib/utils";
import { CircleCheckBig } from "lucide-react";

type Props = {
  isNewAppDisabled: boolean;
  isDeployingNewApp: boolean;
  isDoneDeployingNewApp: boolean;
  isErrorDeployingNewApp: boolean;
};

const GetAppDeploymentStatus = ({
  isNewAppDisabled,
  isDeployingNewApp,
  isDoneDeployingNewApp,
  isErrorDeployingNewApp
}: Props) => {
  return (
    <div
      className={cn(
        "absolute bottom-1 left-auto ml-2 right-2 bg-brand-gray-100 shadow-md dark:shadow-none dark:bg-brand-gray-900 px-2.5 py-1.5 rounded-md",
        !(
          isNewAppDisabled ||
          isDeployingNewApp ||
          isDoneDeployingNewApp ||
          isErrorDeployingNewApp
        ) && "invisible"
      )}
    >
      {(isNewAppDisabled || isDeployingNewApp) && (
        <div className="text-sm text-brand-gray-600 dark:text-brand-gray-200 drop-shadow-sm flex flex-row items-center justify-end gap-x-3 italic">
          <LoadingCircle type="warning" />
          {isNewAppDisabled
            ? "Preparing app for deployment - This may take a moment. Once the app is deployed, you will be able to edit the code."
            : "Deploying app - This may take a moment. Once the app is deployed, you will be able to edit the code."}
        </div>
      )}
      {isDoneDeployingNewApp && (
        <div className="text-sm text-primary dark:text-brand-primary drop-shadow-sm flex flex-row items-center justify-end gap-x-1.5 italic">
          <CircleCheckBig className="h-3 w-3" />
          App deployed!
        </div>
      )}
      {isErrorDeployingNewApp && (
        <div className="text-sm text-brand-error/90 dark:text-brand-error/90 drop-shadow-sm flex flex-row items-center justify-end italic">
          App deployment failed
        </div>
      )}
    </div>
  );
};

export default GetAppDeploymentStatus;
